<template>
  <div
    class="DragResize"
    ref="DragResize"
  >
    <div
      class="DragResize__bar"
      @mousedown.left="handleMousedown"
    >
      <div class="DragResize__title">
          <span style="margin-right:10px;">轨迹信息</span>
          &nbsp;&nbsp;<el-checkbox v-model="posStatus" v-if="false">定位和不定位</el-checkbox>
          <el-checkbox v-model="stopStatus" v-if="false">停车轨迹</el-checkbox>
      </div>
      <!-- <el-button
        title="导出轨迹"
        type="text"
        size="medium"
        icon="iconfont icon-export"
        class="DragResize__exportBtn"
        @click="exportMsg"
      /> -->
      <el-button
        class="DragResize__button"
        :class="{DragResize__button_expanded: expanded}"
        @click="handleExpandBtnClick()"
        type="text"
        icon="el-icon-arrow-up"
      ></el-button>
      <el-button
        class="DragResize__button"
        style="right:40px;font-size:14px"
        @click="exportNoxReport"
        type="text"
        icon="el-icon-download"
      >导出</el-button>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    maxHeight: {
      type: Number,
      default: document.body.clientHeight - 50
    },
    minHeight: {
      type: Number,
      default: 0
    },
    defaultHeigth: {
      type: Number,
      default: 280
    },
    model:{
      type:Object
    }
  },

  data() {
    return {
      posStatus:0,
      stopStatus:0,
      isDrag: false,
      initY: 0,
      upsideH: 0,
      expanded: true //是否展开
    };
  },

  mounted() {
    this.$refs.DragResize.style.height = this.defaultHeigth + "px";
    window.onresize = () => {
      this.maxHeight = document.body.clientHeight - 50;
      if (
        this.$refs.DragResize.clientHeight >
        document.body.clientHeight - 50
      ) {
        this.$refs.DragResize.style.height =
          document.body.clientHeight - 50 + "px";
      }
    };
  },

  beforeDestroy() {
    this.clearEventListener();
  },

  methods: {
    //导出数据
    exportNoxReport(){
      let params = {
        mostParentId:this.$store.state.USER.mostParentId,
        vehicleId:this.model.vehInfo.vehicleId,
        beginTime:this.model.startTime,
        endTime:this.model.endTime,
        filterTime:this.model.filterTime,
      }
      console.log('导出',params)
      this.$API.writePosExcel(params);
    },
    exportMsg() {
      this.$emit("exportMsg");
    },
    async handleExpandBtnClick() {
      this.$refs.DragResize.style.transition = "height 0.3s";
      this.expanded
        ? this.emitOnChange(this.minHeight)
        : this.emitOnChange(this.defaultHeigth);
      await this.$sleep(500);
      this.$refs.DragResize.style.transition = "none";
    },
    async handleMousedown(e) {
      this.isDrag = true;
      this.initY = e.clientY;
      this.upsideH = this.$refs.DragResize.offsetHeight;
      this.clearEventListener();
      document.addEventListener("mousemove", this.handleMousemove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMousemove(e) {
      let changeH = this.upsideH + (this.initY - e.clientY);
      //小于最小宽度则设为最小宽度
      changeH < this.minHeight && (changeH = this.minHeight);
      //大于容器一半宽度则设为容器一半宽度
      changeH > this.maxHeight && (changeH = this.maxHeight);
      this.emitOnChange(changeH);
    },
    emitOnChange(changeH) {
      this.expanded = changeH > this.minHeight;
      this.$emit("onChange", changeH);
      this.$refs.DragResize.style.height = changeH + "px";
    },
    handleMouseUp(e) {
      if (e.button !== 0) return;
      this.clearEventListener();
      this.isDrag = false;
    },
    clearEventListener() {
      document.removeEventListener("mouseup", this.handleMouseUp);
      document.removeEventListener("mousemove", this.handleMousemove);
    }
  }
};
</script>

<style lang="scss" scoped>
.DragResize {
  height: 280px;
  overflow: hidden;

  &__bar {
    position: absolute;
    top: -34px;
    left: 0;
    right: 0;
    height: 34px;
    display: flex;
    align-items: center;
    z-index: 99;
    background-color: #fff;
    user-select: none;
    cursor: n-resize;
  }
  &__title {
    font-weight: 400;
    color: $primary;
    font-size: 14px;
    padding-left: 35px;
  }
  &__exportBtn {
    position: absolute;
    right: 50px;
    font-size: 20px;
  }
  &__button {
    position: absolute;
    right: 10px;
    font-size: 20px;
    transition: transform 0.3s;

    &_expanded {
      transform: rotate(180deg);
    }
  }
}
</style>
